import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} viewport
 * @property {HTMLButtonElement} previous
 * @property {HTMLButtonElement} next
 *
 * @extends Component<Refs>
 */
class PartnerLogosScroller extends Component {
  requiredRefs = ['viewport', 'previous', 'next'];

  connectedCallback() {
    super.connectedCallback();

    this.refs.previous.addEventListener('click', this.#handlePrevious);
    this.refs.next.addEventListener('click', this.#handleNext);
    this.refs.viewport.addEventListener('scroll', this.#updateButtons, { passive: true });
    window.addEventListener('resize', this.#updateButtons);

    this.#updateButtons();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.previous.removeEventListener('click', this.#handlePrevious);
    this.refs.next.removeEventListener('click', this.#handleNext);
    this.refs.viewport.removeEventListener('scroll', this.#updateButtons);
    window.removeEventListener('resize', this.#updateButtons);
  }

  #handlePrevious = () => {
    this.#scroll(-1);
  };

  #handleNext = () => {
    this.#scroll(1);
  };

  /**
   * @param {number} direction
   */
  #scroll(direction) {
    const { viewport } = this.refs;
    const amount = Math.max(viewport.clientWidth * 0.75, 180);

    viewport.scrollBy({
      left: direction * amount,
      behavior: 'smooth',
    });
  };

  #isScrollLayout() {
    const root = this.closest('.partner-logos');
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    if (!isDesktop) return true;
    return Boolean(root?.classList.contains('partner-logos--desktop-scroll'));
  }

  #updateButtons = () => {
    const { viewport, previous, next } = this.refs;

    if (!this.#isScrollLayout()) {
      previous.disabled = true;
      next.disabled = true;
      return;
    }

    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    previous.disabled = viewport.scrollLeft <= 1;
    next.disabled = viewport.scrollLeft >= maxScrollLeft - 1;
  };
}

if (!customElements.get('partner-logos-scroller')) {
  customElements.define('partner-logos-scroller', PartnerLogosScroller);
}
